<template>
  <a
    href="javascript: void(0)"
    class="suspend-button"
    ref="suspendBtn"
    @click="handleClick"
    @touchstart="handleTouchStart"
    @touchmove="handleTouchMove"
    @touchend="handleTouchEnd"
    :style="positionStyle"
  >
    <template v-if="$slots.default">
      <slot></slot>
    </template>
  </a>
</template>
<script>
export default {
  name: 'suspendButton',
  props: {},
  data() {
    return {
      oLeft: '',
      oTop: ''
    };
  },
  computed: {
    positionStyle() {
      return {
        top: this.oTop + 'px',
        left: this.oLeft + 'px'
      };
    }
  },
  created() {
    this.moving = false; // 移动状态
    this.oW = null; // 悬钮距离
    this.oH = null;
    this.htmlWidth = null; // 页面宽度
    this.htmlHeight = null;
    this.bWidth = null; // 悬钮宽度
    this.bHeight = null;
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
    handleTouchStart(e) {
      e = e.touches[0];

      this.oW =
        e.clientX - this.$refs['suspendBtn'].getBoundingClientRect().left;
      this.oH =
        e.clientY - this.$refs['suspendBtn'].getBoundingClientRect().top;

      this.htmlWidth = document.documentElement.clientWidth;
      this.htmlHeight = document.documentElement.clientHeight;

      this.bWidth = this.$refs['suspendBtn'].offsetWidth;
      this.bHeight = this.$refs['suspendBtn'].offsetHeight;

      this.oLeft = e.clientX - this.oW;
      this.oTop = e.clientY - this.oH;
      this.moving = true;
    },
    handleTouchMove(e) {
      this.moving && this.onMove(e);
    },
    onMove(e) {
      e.preventDefault();
      e = e.touches[0];

      // 左侧距离
      let oLeft = e.clientX - this.oW;
      let oTop = e.clientY - this.oH;
      if (oLeft < 0) {
        oLeft = 0;
      } else if (oLeft > this.htmlWidth - this.bWidth) {
        oLeft = this.htmlWidth - this.bWidth;
      }
      if (oTop < 0) {
        oTop = 0;
      } else if (oTop > this.htmlHeight - this.bHeight) {
        oTop = this.htmlHeight - this.bHeight;
      }
      this.oLeft = oLeft;
      this.oTop = oTop;
      // 暂时用上面的方案
      // this.$refs['suspendBtn'].style.left = oLeft + 'px';
      // this.$refs['suspendBtn'].style.top = oTop + 'px';
    },
    handleTouchEnd() {
      this.moving = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.suspend-button {
  position: fixed;
  bottom: 100px;
  right: 16px;
  z-index: 9999;
  width: 52px;
  height: 52px;
  color: #fff;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2)
    ),
    #3873fa;
  box-shadow: 3px 1px 4px rgba(168, 193, 224, 0.4),
    3px 1px 10px rgba(177, 199, 226, 0.3);
  border-radius: 50%;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>